import React from 'react';
import requiredIf from 'react-required-if';
import PropTypes from 'prop-types';

import { withStyles } from '~/assets/withStyles';
import cn from '~/Utils/cn';

import { PencilIcon } from './icons';
import InlineIconButton from './InlineIconButton';

import styles from '../assets/styles';

const HoverActionField = ({
  children,
  classes,
  disabled = false,
  permanent,
  onAction,
  icon,
  iconStyle,
  fullWidth,
  highlight,
  tooltipTitle,
  centerContent,
  style = {},
  ignorePermissions = false,
  actionAriaLabel,
  actionTriggerAria,
}) => {
  return (
    <div
      className={cn('group/hover-action-field', { [classes.showValueEditableField]: highlight })}
      style={fullWidth ? { ...style, width: '100%' } : style}
    >
      <span
        className={classes.showValueField}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: centerContent ? 'center' : undefined,
          width: '100%',
        }}
      >
        {/* min-w-0 so this content cell can shrink below its content inside the inline-flex row,
            letting a long value (e.g. a contact name) truncate within the column instead of
            overflowing and overlaying adjacent fields. */}
        <span className={cn('min-w-0', 'h-full', fullWidth ? 'w-full' : null)}>{children}</span>
        <span
          className={cn(
            'self-end',
            { 'opacity-0 focus-within:opacity-100 group-hover/hover-action-field:opacity-100': !permanent },
            { invisible: disabled && !permanent }
          )}
        >
          <InlineIconButton
            className={classes.hoverableNonFilledIcon}
            icon={icon ? icon : PencilIcon}
            onClick={(e) => onAction(e)}
            tooltipTitle={tooltipTitle}
            iconStyle={iconStyle}
            disabled={disabled}
            ignorePermissions={ignorePermissions}
            ariaLabel={actionAriaLabel}
            {...actionTriggerAria}
          />
        </span>
      </span>
    </div>
  );
};

HoverActionField.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.object.isRequired, // comes from withStyles
  disabled: PropTypes.bool,
  icon: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  iconStyle: PropTypes.object,
  style: PropTypes.object,
  permanent: PropTypes.bool,
  highlight: PropTypes.bool,
  onAction: requiredIf(PropTypes.func, (props) => !props.disabled),
  fullWidth: PropTypes.bool,
  tooltipTitle: PropTypes.string,
  centerContent: PropTypes.bool,
  ignorePermissions: PropTypes.bool,
  actionAriaLabel: PropTypes.string,
  // For an action that opens a popover: the attributes `getPopoverTriggerAria` returns, for the button.
  actionTriggerAria: PropTypes.shape({
    'aria-haspopup': PropTypes.oneOf(['dialog']),
    'aria-expanded': PropTypes.bool,
    'aria-controls': PropTypes.string,
  }),
};

export default withStyles(HoverActionField, styles);
